let currentGalleryIndex = 0;
const disabledClasses = ["opacity-50", "cursor-not-allowed"];

function disableButton(button) {
  const btn = button;
  btn.disabled = true;
  btn.classList.add(...disabledClasses);
}

function enableButton(button) {
  const btn = button;
  btn.removeAttribute("disabled");
  btn.classList.remove(...disabledClasses);
}

function updateIndicator(i, indicator) {
  const currentIndicator = indicator.querySelector("[data-gallery-current]");
  currentIndicator.innerHTML = i;
}

function moveGallery(dir, leftButton, rightButton, indicator, galleryItems) {
  const firstGalleryItem = galleryItems[0];
  
  currentGalleryIndex += dir;

  firstGalleryItem.style.marginLeft = `${-100 * currentGalleryIndex}vw`;

  if (currentGalleryIndex > 0) {
    enableButton(leftButton);
  } else {
    disableButton(leftButton);
  }

  if (currentGalleryIndex === galleryItems.length - 1) {
    disableButton(rightButton);
  } else {
    enableButton(rightButton);
  }

  updateIndicator(currentGalleryIndex + 1, indicator);
}

function Gallery(el) {
  const track = el.querySelector("[data-gallery-track]");
  const leftButton = el.querySelector("[data-gallery-left]");
  const rightButton = el.querySelector("[data-gallery-right]");
  const indicator = el.querySelector("[data-gallery-indicator]");
  const galleryItems = el.querySelectorAll("[data-gallery-item]");

  if (galleryItems.length > 1) {
    track.classList.add("flex-nowrap");
    track.classList.remove("flex-wrap");
    leftButton.classList.remove("hidden");
    rightButton.classList.remove("hidden");
    indicator.classList.remove("hidden");

    disableButton(leftButton);

    leftButton.addEventListener("click", function() {
      moveGallery(-1, leftButton, rightButton, indicator, galleryItems);
    });

    rightButton.addEventListener("click", function() {
      moveGallery(1, leftButton, rightButton, indicator, galleryItems);
    });
  }
}

export function bindGallery() {
  return [...document.querySelectorAll("[data-gallery]")].map((el) => Gallery(el));
}
